export default {"src":"/_next/static/media/badge.9361a6d9.svg","height":68,"width":68};